import { CanvasObject } from './CanvasObject';

const RING_GROW_SPEED = 1;

export class Ring {

  public radiusTarget: number;
  public initialRad: number;
  private counted: boolean = false;
  constructor(private x: number, private y: number, public radius: number) {
    this.initialRad = radius;
    this.radiusTarget = radius + (radius / 2);
  }

  public draw(c: CanvasRenderingContext2D): void {
    c.beginPath();
    c.lineWidth = 1;
    c.shadowBlur = 0;
    c.arc(this.x, this.y, this.radius, Math.PI * 2, 0, false);
    c.strokeStyle = '#ffc';
    c.stroke();
  }

  public update(c: CanvasRenderingContext2D, x: number, y: number, radius: number): void {
    this.x = x;
    this.y = y;
    this.radius = radius;
    this.draw(c);
  }

  public expand() {
    this.radius += RING_GROW_SPEED;
  }

  public shrink() {
    this.radius -= RING_GROW_SPEED;
  }

}
